module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0180.jpg?v=7e2eddf9";